import {
    Link, useParams,
} from "react-router-dom";
import {Posts} from "./Posts";

export function Category() {
    let { category } = useParams();

    if(category === "open-photo-space") {
        category = "vzdelavacie-aktivity";
    } else if(category === "vystavy") {
        category = "aktualne-akcie";
    }
    return Posts[category].map((article) => {
        return <div className="card" key={article.id}>
            <div className="card-cover" style={{
                backgroundImage: "url(" + article.banner + ")"
            }}></div>

            <div className="card-header">
                <div className="heading">{article.heading}</div>
                {article.date && <div className="date">{article.date}</div>}
            </div>
            <div className="card-body">
                {
                    article.content
                }
                <Link to={typeof article.link === "object" ? article.link.link : article.link}>{typeof article.link === "object" ? article.link.label : "Pokračovať v čítaní"}</Link>
                {
                    article.secondLink ? <Link to={typeof article.secondLink === "object" ? article.secondLink.link : article.secondLink} className={"curators-text"}>{typeof article.secondLink === "object" ? article.secondLink.label : "Kurátorský text"}</Link> : undefined
                }
            </div>
        </div>
    })

}